export default {"columnViewport":"I4i7WG_columnViewport","inline":"I4i7WG_inline","columnContainer":"I4i7WG_columnContainer","column":"I4i7WG_column",}